export const transaltionResources = {
    sk: {
        translation: {
            Baguettes: 'Bagety',
            MinWeight: 'Min. hmotnosť',
            Slovak: 'Slovenský',
            Hungarian: 'Magyar',
            CookieConsentHeader: 'Nastavenie ukladania cookies',
            CookieConsentDescription: 'Táto webstránka používa súbory cookies na prispôsobenie obsahu, poskytovanie funkcií sociálnych médií a na analýzu návštevnosti. Informácie o tom, ako používate naše webové stránky, poskytujeme aj našim partnerom v oblasti sociálnych médií, inzercie a analýzy. Títo partneri môžu príslušné informácie skombinovať s ďalšími údajmi, ktoré ste im poskytli alebo ktoré od vás získali, keď ste používali ich služby.',
            AcceptAll: 'Prijať všetko',
            Options: 'Možnosti',
            Basic: 'Základné',
            BasicDescription: 'Tieto položky sú potrebné na povolenie základných funkcií webových stránok.',
            Analytics: 'Analytika',
            AnalyticsDescription: 'Tieto položky pomáhajú prevádzkovateľovi webových stránok pochopiť výkonnosť jeho webových stránok, interakciu návštevníkov so stránkou a prípadné technické problémy. Tento typ úložiska zvyčajne nezhromažďuje informácie, ktoré identifikujú návštevníka.',
            Close: 'Zatvoriť',
            Save: 'Uložiť',
            CookieConsentDetailedDescription: 'Cookies sú malé textové súbory, ktoré môžu byť použité webovými stránkami, aby zefektívnili užívateľovu skúsenosť.\n' +
                'Zákon hovorí, že môžeme ukladať súbory cookie na vašom zariadení, ak sú nevyhnutné pre prevádzku týchto stránok. Pri všetkých ostatných typoch súborov cookie potrebujeme váš súhlas.\n' +
                'Táto stránka používa rôzne typy cookies. Niektoré cookies sú tu umiestnené službami tretích strán, ktoré sa objavujú na našich stránkach. Svoj súhlas so Zásadami cookies môžete kedykoľvek zmeniť alebo odvolať na našej webovej stránke.',
            DataSecurity: 'Ochrana osobných údajov',
            Bageta1: 'šunková',
            Bageta2: 'šunkovo-kukuričná',
            Bageta3: 'šunkovo-šampiónová',
            Bageta4: 'šunková pikantná',
            Bageta5: 'šunkovo-klobásová',
            Bageta6: 'extra',
            Bageta7: 'extra pikantná',
            Bageta8: 'klobásová',
            Bageta9: 'syrová',
            Bageta10: 'syrová-vega',
            Bageta11: 'vega',
            Bageta12: 'tuniaková',
            Bageta13: 'lososová',
            Bageta14: 'slaninová',
            Bageta15: 'slaninovo-klobásová',
            Bageta1Description: 'šunka, syr, kapusta, paprika, paradajky, uhorka, tatárska omáčka',
            Bageta2Description: 'šunka, syr, kukurica, kapusta, paprika, paradajky, uhorka, tatárska omáčka',
            Bageta3Description: 'šunka, syr, šampióny, kapusta, paprika, paradajky, uhorka, tatárska omáčka',
            Bageta4Description: 'šunka, syr, kapusta, paprika, paradajky, uhorka, tatárska omáčka, feferónky',
            Bageta5Description: 'šunka, syr, klobása, paprika, paradajky, kapusta, uhorka, tatárska omáčka',
            Bageta6Description: 'šunka, syr, šampióny, kukurica, kapusta, paprika, paradajky, uhorka, tatárska omáčka',
            Bageta7Description: 'šunka, syr, šampióny, kukurica, kapusta, paprika, paradajky, uhorka, tatárska omáčka, feferónky',
            Bageta8Description: 'klobása, syr, šampióny, kukurica, kapusta, paprika, paradajky, uhorka, tatárska omáčka',
            Bageta9Description: 'syr eidam, udený syr, tatárska omáčka',
            Bageta10Description: 'syr eidam, udený syr, paprika, paradajky, kukurica, šampióny, uhorka, kapusta, tatárska omáčka',
            Bageta11Description: 'paprika, paradajky, kukurica, šampióny, uhorka, kapusta, tatárska omáčka',
            Bageta12Description: 'tuniak, paprika, paradajky, kapusta, uhorka, tatárska omáčka',
            Bageta13Description: 'losos, paprika, paradajky, kapusta, uhorka, tatárska omáčka',
            Bageta14Description: 'oravská slanina, syr, paprika, paradajka, cibula, tatárska omáčka',
            Bageta15Description: 'oravská slanina, klobása, syr, cibula, tatárska omáčka',
            BakedIn: 'Zapekačky',
            Zapekac1: 'šunková',
            Zapekac2: 'šunkovo-kukuričná',
            Zapekac3: 'šunkovo-šampiónová',
            Zapekac4: 'šunková pikantná',
            Zapekac5: 'šunkovo-klobásová',
            Zapekac6: 'extra',
            Zapekac7: 'extra pikantná',
            Zapekac8: 'full extra',
            Zapekac9: 'full extra pikantná',
            Zapekac10: 'klobásová',
            Zapekac11: 'šunkovo-lososová',
            Zapekac12: 'syrová',
            Zapekac13: 'lososová',
            Zapekac14: 'tuniaková',
            Zapekac15: 'slaninová',
            Zapekac16: 'slaninovo-klobásová',
            Zapekac1Description: 'šunka, udený syr, vegeta, tatárska omáčka',
            Zapekac2Description: 'šunka, kukurica, udený syr, vegeta, tatárska omáčka',
            Zapekac3Description: 'šunka, šampióny, udený syr, vegeta, tatárska omáčka',
            Zapekac4Description: 'šunka, udený syr, vegeta, tatárska omáčka, feferónky',
            Zapekac5Description: 'šunka, klobása, udený syr, vegeta, tatárska omáčka',
            Zapekac6Description: 'šunka, udený syr, šampióny, kukurica, vegeta, tatárska omáčka',
            Zapekac7Description: 'šunka, udený syr, šampióny, kukurica, vegeta, tatárska omáčka, feferónky',
            Zapekac8Description: 'šunka, klobása, udený syr, šampióny, kukurica, tatárska omáčka',
            Zapekac9Description: 'šunka, klobása, udený syr, šampióny, kukurica, tatárska omáčka, feferónky',
            Zapekac10Description: 'klobása, udený syr, vegeta, tatárska omáčka',
            Zapekac11Description: 'šunka, losos, udený syr, tatárska omáčka',
            Zapekac12Description: 'syr eidam, udený syr, vegeta, tatárska omáčka',
            Zapekac13Description: 'losos, udený syr, tatárska omáčka',
            Zapekac14Description: 'tuniak, udený syr, vegeta, tatárska omáčka',
            Zapekac15Description: 'oravská slanina, syr, cibula, tatárska omáčka',
            Zapekac16Description: 'oravská slanina, klobása, syr, cibula, tatárska omáčka',
            Hamburger1: 'Kurací, 150g',
            Hamburger2: 'Kurací so syrom, 155g',
            Hamburger1Description: 'kuracie mäso, paprika, paradajka, uhorka, kapusta, horčica, kečup',
            Hamburger2Description: 'kuracie mäso, syr, paprika, paradajka, uhorka, kapusta, horčica, kečup',
            HotDog1: 'Hot dog, 100g',
            HotDog2: 'Americký hot dog, 120g',
            HotDog3: 'Zapečený hot dog, 110g',
            HotDog1Description: 'párok, horčica alebo kečup',
            HotDog2Description: 'horčica, párok, udený syr, šampióny, kukurica, kapusta, kečup',
            HotDog3Description: 'horčica, párok, udený syr, kečup',
            Dressing1: 'Šunka, slanina, klobása, tuniak, losos, párky, mäsový hamburger, syr, udený syr',
            Dressing2: 'Paprika, paradajka, uhorka, kapusta, cibuľa, kukurica, huby',
            Drink1: 'Coca cola, Sprite, Fanta, Fuze tea 0,5l',
            Drink2: 'Cappy 0,33l',
            Drink3: 'Bonaqua 0,5l',
            Drink4: 'Red Bull 0,25l',
            Drink5: 'Hell 0,25l',
            Drink6: 'Káva',
            Drink7: 'Všetky flaše nápojov sú zálohované',
            Hamburger: 'Hamburger',
            HotDog: 'Hot Dog',
            Dressing: 'Prílohy',
            Drinks: 'Nápoje',
            Location: 'Bacsákova 4,92901 Dunajská Streda',
            FromMondayToFriday: 'Pondelok - Piatok',
            Saturday: 'Sobota',
            Sunday: 'Nedeľa',
            Closed: 'Zatvorené',
            OpeningHours: 'Otváracia doba',
            Allergens: 'Alergény',
            Milk: 'Mlieko / Laktóza',
            Fish: 'Ryby',
            Mustard: 'Horčica',
            Eggs: 'Vajcia',
            SezameSeeds: 'Sezamové semená',
            Cereals: 'Obilniny',
            Soja: 'Sójové bôby / Sója',
            Gluten: 'Lepok',
        }
    },
    hu: {
        translation: {
            Baguettes: 'Bageták',
            MinWeight: 'Min. súly',
            Slovak: 'Slovenský',
            Hungarian: 'Magyar',
            CookieConsentHeader: 'Cookie-tárolási beállítások',
            CookieConsentDescription: 'Ez a weboldal cookie-kat használ a tartalom testreszabására, a közösségi média funkciók biztosítására és a forgalom elemzésére. Ezenkívül tájékoztatást adunk közösségi médiás, hirdetési és elemzési partnereinknek arról, hogyan használja weboldalunkat. Ezek a partnerek egyesíthetik a releváns információkat más adatokkal, amelyeket Ön a szolgáltatásaik igénybevételekor megadott nekik, vagy kapott Öntől.',
            AcceptAll: 'Mindent elfogadni',
            Options: 'Lehetőségek',
            Basic: 'Általános',
            BasicDescription: 'Ezek az elemek szükségesek a webhely alapvető funkcióinak működéséhez.',
            Analytics: 'Analitika',
            AnalyticsDescription: 'Ezek az elemek segítenek a webhely üzemeltetőjének megérteni webhelye teljesítményét, a látogatók interakcióját az oldallal és az esetleges technikai problémákat. Az ilyen típusú tárolás általában nem gyűjt olyan információkat, amelyek azonosítják a látogatót.',
            Close: 'Bezárás',
            Save: 'Mentés',
            CookieConsentDetailedDescription: 'A sütik kis szöveges fájlok, amelyeket a webhelyek a felhasználói élmény javítására használhatnak.\n' +
                'A törvény kimondja, hogy cookie-kat tárolhatunk az Ön eszközén, ha ezek az oldalak működéséhez szükségesek. Minden más típusú sütihez az Ön hozzájárulására van szükségünk.\n' +
                'Ez az oldal különböző típusú sütiket használ. Néhány cookie-t az oldalainkon megjelenő harmadik fél szolgáltatásai helyeznek el ide. Weboldalunkon bármikor megváltoztathatja vagy visszavonhatja a Cookie-szabályzathoz való hozzájárulását.',
            DataSecurity: 'Adatvédelem',
            Bageta1: 'sonkás',
            Bageta2: 'sonkás-kukoricás',
            Bageta3: 'sonkás-szampinyonos',
            Bageta4: 'sonkás pikáns',
            Bageta5: 'sonkás-kolbászos',
            Bageta6: 'extra',
            Bageta7: 'extra pikáns',
            Bageta8: 'kolbászos',
            Bageta9: 'sajtos',
            Bageta10: 'sajtos-vega',
            Bageta11: 'vega',
            Bageta12: 'tonhalas',
            Bageta13: 'lazacos',
            Bageta14: 'szalonnás',
            Bageta15: 'szalonna-kolbászos',
            Bageta1Description: 'sonka, sajt, káposzta, paprika, paradicsom, uborka, tatár',
            Bageta2Description: 'sonka, sajt, kukorica, káposzta, paprika, paradicsom, uborka, tatár',
            Bageta3Description: 'sonka, sajt, szampinyon, káposzta, paprika, paradicsom, uborka, tatár',
            Bageta4Description: 'sonka, sajt, káposzta, paprika, paradicsom, uborka, tatár, csili',
            Bageta5Description: 'sonka, sajt, kolbász, paprika, paradicsom, káposzta, uborka, tatár',
            Bageta6Description: 'sonka, sajt, szampinyon, kukorica, káposzta, paprika, paradicsom, uborka, tatár',
            Bageta7Description: 'sonka, sajt, szampinyon, kukorica, káposzta, paprika, paradicsom, uborka, tatár, csili',
            Bageta8Description: 'kolbász, sajt, szampinyon, kukorica, káposzta, paprika, paradicsom, uborka, tatár',
            Bageta9Description: 'eidam sajt, füstölt sajt, tatár',
            Bageta10Description: 'eidam sajt, füstölt sajt, paprika, paradicsom, kukorica, szampinyon, uborka, káposzta, tatár',
            Bageta11Description: 'paprika, paradicsom, kukorica, szampinyon, uborka, káposzta, tatár',
            Bageta12Description: 'tonhal, paprika, paradicsom, káposzta, uborka, tatár',
            Bageta13Description: 'lazac, paprika, paradicsom, káposzta, uborka, tatár',
            Bageta14Description: 'orávai szalonna, sajt, paprika, paradicsom, hagyma, tatár',
            Bageta15Description: 'orávai szalonna, kolbász, sajt, hagyma, tatár',
            BakedIn: 'Besütöttek',
            Zapekac1: 'sonkás',
            Zapekac2: 'sonkás kukoricás',
            Zapekac3: 'sonkás gombás',
            Zapekac4: 'sonkás pikáns',
            Zapekac5: 'sonkás-kolbászos',
            Zapekac6: 'extra',
            Zapekac7: 'extra pikáns',
            Zapekac8: 'full extra',
            Zapekac9: 'full extra pikáns',
            Zapekac10: 'kolbászos',
            Zapekac11: 'sonkás-lazacos',
            Zapekac12: 'sajtos',
            Zapekac13: 'lazacos',
            Zapekac14: 'tonhalas',
            Zapekac15: 'szalonnás',
            Zapekac16: 'szalonna-kolbászos',
            Zapekac1Description: 'sonka, füstölt sajt, vegeta, tatár',
            Zapekac2Description: 'sonka, kukorica, füstölt sajt, vegeta, tatár',
            Zapekac3Description: 'sonka, gomba, füstölt sajt, vegeta, tatár',
            Zapekac4Description: 'sonka, füstölt sajt, vegeta, tatár, csilipaprika',
            Zapekac5Description: 'sonka, kolbász, füstölt sajt, vegeta, tatár',
            Zapekac6Description: 'sonka, füstölt sajt, gomba, kukorica, vegeta, tatár',
            Zapekac7Description: 'sonka, füstölt sajt, gomba, kukorica, vegeta, tatár, csilipaprika',
            Zapekac8Description: 'sonka, kolbász, füstölt sajt, gomba, kukorica, tatár',
            Zapekac9Description: 'sonka, kolbász, füstölt sajt, gomba, kukorica, tatár, csilipaprika',
            Zapekac10Description: 'kolbász, füstölt sajt, vegeta, tatár',
            Zapekac11Description: 'sonka, lazac, füstölt sajt, tatár',
            Zapekac12Description: 'eidam sajt, füstölt sajt, vegeta, tatár',
            Zapekac13Description: 'lazac, füstölt sajt, tatár',
            Zapekac14Description: 'tonhal, füstölt sajt, vegeta, tatár',
            Zapekac15Description: 'oráviai szalonna, sajt, hagyma, tatár',
            Zapekac16Description: 'oráviai szalonna, kolbász, sajt, hagyma, tatár',
            Hamburger1: 'Csirkés, 150g',
            Hamburger2: 'Csirkés sajttal, 155g',
            Hamburger1Description: 'csirkehús, paprika, paradicsom, uborka, káposzta, mustár, kecsap',
            Hamburger2Description: 'csirkehús, sajt, paprika, paradicsom, uborka, káposzta, mustár, kecsap',
            HotDog1: 'Hot dog, 100g',
            HotDog2: 'Amerikai hot dog, 120g',
            HotDog3: 'Sült hot dog, 110g',
            HotDog1Description: 'virsli, mustár vagy kecsap',
            HotDog2Description: 'mustár, virsli, füstölt sajt, sampinyon, kukorica, káposzta, kecsap',
            HotDog3Description: 'mustár, virsli, füstölt sajt, kecsap',
            Dressing1: 'Sonka,szalonna,kolbász,tonhal,lazac,virsli,hamburger hús,sajt,füstölt sajt',
            Dressing2: 'Paprika,paradicsom,uborka,káposzta,hagyma,kukorica,gomba',
            Drink1: 'Cola, Fanta, Sprite, Fuze tea 0,5l',
            Drink2: 'Cappy 0,33l',
            Drink3: 'Bonaqua 0,5l',
            Drink4: 'Redbull 0.25l',
            Drink5: 'Hell 0,25l',
            Drink6: 'Kávé',
            Drink7: 'Minden italos palack vissza váltható',
            Hamburger: 'Hamburger',
            HotDog: 'Hot Dog',
            Dressing: 'Köretek',
            Drinks: 'Üdítőitalok',
            Location: 'Bacsák utca 4,92901 Dunaszerdahely',
            FromMondayToFriday: 'Hétfő - Péntek',
            Saturday: 'Szombat',
            Sunday: 'Vasárnap',
            Closed: 'Zárva',
            OpeningHours: 'Nyitvatartás',
            Allergens: 'Alergének',
            Milk: 'Tej / Laktóz',
            Fish: 'Hal',
            Mustard: 'Mustár',
            Eggs: 'Tojás',
            SezameSeeds: 'Szezámmag',
            Cereals: 'Gabonafélék',
            Soja: 'Szója',
            Gluten: 'Glutén',
        }
    },
    en: {
        translation: {
            Baguettes: 'Baguettes',
            MinWeight: 'Min. weight',
            Slovak: 'Slovak',
            Hungarian: 'Hungarian',
            CookieConsentHeader: 'Cookie storage settings',
            CookieConsentDescription: 'This website uses cookies to customize content, provide social media features, and analyze traffic. In addition, we inform our social media, advertising, and analytics partners about how you use our website. These partners may combine the relevant information with other data you have provided to them or received from you when using their services.',
            AcceptAll: 'Accept all',
            Options: 'Options',
            Basic: 'General',
            BasicDescription: 'These elements are necessary for the basic functions of the website to work.',
            Analytics: 'Analytics',
            AnalyticsDescription: 'These elements help the website operator understand the performance of the website, the interaction of visitors with the site, and any technical problems. This type of storage usually does not collect information that identifies the visitor.',
            Close: 'Close',
            Save: 'Save',
            CookieConsentDetailedDescription: 'Cookies are small text files that websites can use to improve the user experience.\n' +
                'The law states that we can store cookies on your device if they are necessary for the operation of these pages. For all other types of cookies, we need your consent.\n' +
                'This site uses different types of cookies. Some cookies are placed by third-party services that appear on our pages. You can change or withdraw your consent to the Cookie Policy at any time on our website.',
            DataSecurity: 'Data Protection',
            Bageta1: 'ham',
            Bageta2: 'ham and corn',
            Bageta3: 'ham and mushroom',
            Bageta4: 'spicy ham',
            Bageta5: 'ham and sausage',
            Bageta6: 'extra',
            Bageta7: 'extra spicy',
            Bageta8: 'sausage',
            Bageta9: 'cheese',
            Bageta10: 'cheese vegan',
            Bageta11: 'vegan',
            Bageta12: 'tuna',
            Bageta13: 'salmon',
            Bageta14: 'bacon',
            Bageta15: 'bacon and sausage',
            Bageta1Description: 'ham, cheese, cabbage, pepper, tomato, cucumber, tartar',
            Bageta2Description: 'ham, cheese, corn, cabbage, pepper, tomato, cucumber, tartar',
            Bageta3Description: 'ham, cheese, mushroom, cabbage, pepper, tomato, cucumber, tartar',
            Bageta4Description: 'ham, cheese, cabbage, pepper, tomato, cucumber, tartar, chili',
            Bageta5Description: 'ham, cheese, sausage, pepper, tomato, cabbage, cucumber, tartar',
            Bageta6Description: 'ham, cheese, mushroom, corn, cabbage, pepper, tomato, cucumber, tartar',
            Bageta7Description: 'ham, cheese, mushroom, corn, cabbage, pepper, tomato, cucumber, tartar, chili',
            Bageta8Description: 'sausage, cheese, mushroom, corn, cabbage, pepper, tomato, cucumber, tartar',
            Bageta9Description: 'edam cheese, smoked cheese, tartar',
            Bageta10Description: 'edam cheese, smoked cheese, pepper, tomato, corn, mushroom, cucumber, cabbage, tartar',
            Bageta11Description: 'pepper, tomato, corn, mushroom, cucumber, cabbage, tartar',
            Bageta12Description: 'tuna, pepper, tomato, cabbage, cucumber, tartar',
            Bageta13Description: 'salmon, pepper, tomato, cabbage, cucumber, tartar',
            Bageta14Description: 'Orava bacon, cheese, pepper, tomato, onion, tartar',
            Bageta15Description: 'Orava bacon, sausage, cheese, onion, tartar',
            BakedIn: 'Baked in food',
            Zapekac1: 'ham',
            Zapekac2: 'ham and corn',
            Zapekac3: 'ham and mushroom',
            Zapekac4: 'spicy ham',
            Zapekac5: 'ham and sausage',
            Zapekac6: 'extra',
            Zapekac7: 'extra spicy',
            Zapekac8: 'full extra',
            Zapekac9: 'full extra spicy',
            Zapekac10: 'sausage',
            Zapekac11: 'ham and salmon',
            Zapekac12: 'cheese',
            Zapekac13: 'salmon',
            Zapekac14: 'tuna',
            Zapekac15: 'bacon',
            Zapekac16: 'bacon and sausage',
            Zapekac1Description: 'ham, smoked cheese, vegeta, tartar',
            Zapekac2Description: 'ham, corn, smoked cheese, vegeta, tartar',
            Zapekac3Description: 'ham, mushrooms, smoked cheese, vegeta, tartar',
            Zapekac4Description: 'ham, smoked cheese, vegeta, tartar, chili pepper',
            Zapekac5Description: 'ham, sausage, smoked cheese, vegeta, tartar',
            Zapekac6Description: 'ham, smoked cheese, mushrooms, corn, vegeta, tartar',
            Zapekac7Description: 'ham, smoked cheese, mushrooms, corn, vegeta, tartar, chili pepper',
            Zapekac8Description: 'ham, sausage, smoked cheese, mushrooms, corn, tartar',
            Zapekac9Description: 'ham, sausage, smoked cheese, mushrooms, corn, tartar, chili pepper',
            Zapekac10Description: 'sausage, smoked cheese, vegeta, tartar',
            Zapekac11Description: 'ham, salmon, smoked cheese, tartar',
            Zapekac12Description: 'eidam cheese, smoked cheese, vegeta, tartar',
            Zapekac13Description: 'salmon, smoked cheese, tartar',
            Zapekac14Description: 'tuna, smoked cheese, vegeta, tartar',
            Zapekac15Description: 'orava bacon, cheese, onion, tartar',
            Zapekac16Description: 'orava bacon, sausage, cheese, onion, tartar',
            Hamburger1: 'Chicken, 150g',
            Hamburger2: 'Chicken with cheese, 155g',
            Hamburger1Description: 'chicken meat, pepper, tomato, cucumber, cabbage, mustard, ketchup',
            Hamburger2Description: 'chicken meat, cheese, pepper, tomato, cucumber, cabbage, mustard, ketchup',
            HotDog1: 'Hot dog, 100g',
            HotDog2: 'American hot dog, 120g',
            HotDog3: 'Baked hot dog, 110g',
            HotDog1Description: 'frankfurter, mustard or ketchup',
            HotDog2Description: 'mustard, frankfurter, smoked cheese, champignon, corn, cabbage, ketchup',
            HotDog3Description: 'mustard, frankfurter, smoked cheese, ketchup',
            Dressing1: 'Ham, bacon, sausage, tuna, salmon, frankfurter, hamburger meat, cheese, smoked cheese',
            Dressing2: 'Bell pepper, tomato, cucumber, cabbage, onion, corn, mushroom',
            Drink1: 'Coca cola, Sprite, Fanta, Fuze tea 0,5l',
            Drink2: 'Cappy 0,33l',
            Drink3: 'Bonaqua 0,5l',
            Drink4: 'Red Bull 0,25l',
            Drink5: 'Hell 0,25l',
            Drink6: 'Caffe',
            Drink7: 'All beverage bottles are returnable',
            Hamburger: 'Hamburger',
            HotDog: 'Hot Dog',
            Dressing: 'Dressing',
            Drinks: 'Drinks',
            Location: 'Bacsákova 4,92901 Dunajská Streda',
            FromMondayToFriday: 'Monday - Friday',
            Saturday: 'Saturday',
            Sunday: 'Sunday',
            Closed: 'Closed',
            OpeningHours: 'Opening hours',
            Allergens: 'Allergens',
            Milk: 'Milk / Lactose',
            Fish: 'Fish',
            Mustard: 'Mustard',
            Eggs: 'Eggs',
            SezameSeeds: 'Sezame seeds',
            Cereals: 'Cereals / Grains',
            Soja: 'Soybeans / Soy',
            Gluten: 'Gluten',
        }
    }
};